export interface InsuranceDestination {
  value: string;
  label: string;
  id: number;
}

export const INSURANCE_BASE_URL = "https://insurance.zdev.tech/PERU";

export const INSURANCE_DESTINATIONS: InsuranceDestination[] = [
  {
    value: "Seleccionedestino",
    label: "Destino",
    id: 0,
  },
  {
    value: "Africa",
    label: "África",
    id: 1,
  },
  {
    value: "America del norte",
    label: "América del norte",
    id: 2,
  },
  {
    value: "América del Sur (salvo Vzla)",
    label: "América del Sur",
    id: 3,
  },
  {
    value: "Asia",
    label: "Asia",
    id: 4,
  },
  {
    value: "Centro america/Caribe",
    label: "Centro América/Caribe",
    id: 5,
  },
  {
    value: "Europa",
    label: "Europa",
    id: 6,
  },
  {
    value: "Internacional Mundo",
    label: "Internacional Mundo",
    id: 7,
  },
  {
    value: "Oceanía",
    label: "Oceanía",
    id: 8,
  },
  {
    value: "Territorio Nacional",
    label: "Territorio Nacional",
    id: 9,
  },
];
